module.exports = __webpack_public_path__ + "img/zuoye1.71d7dce9.png";